// extracted by mini-css-extract-plugin
export var termsPage = "index-module--termsPage--huT6y";